module.exports = __webpack_public_path__ + "img/default-movie-poster.611365b1.png";